import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-recruitment-process',
  templateUrl: './recruitment-process.component.html',
  styleUrls: ['./recruitment-process.component.scss']
})
export class RecruitmentProcessComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
